<template>
    <div>
        <v-card :loading="(cargando)?'blue-grey':null" loader-height="8px" elevation="0">
            <v-toolbar :color=this.$azulUnarsa rounded="0" elevation="5" class="fixed-bar">
                <v-btn icon dark @click="atras"><v-icon>mdi-arrow-left</v-icon></v-btn>
                <v-card-title style="color:#ffff">{{this.$route.params.agrupador.toUpperCase()}}</v-card-title>
            </v-toolbar>
            <div class="ml-2 mr-2 mt-5 text-center" v-if="this.$route.params.agrupador=='favoritos'">
                <v-text-field autofocus type="search" v-model="busqueda" color="blue-grey" prepend-inner-icon="mdi-magnify" 
                    label="Buscar Producto"
                    outlined
                    clearable
                    @keyup.enter="buscar"
                ></v-text-field>
            </div>
            <div style="margin-inline: 15px;" class="mb-12 mt-1" >
                <v-list three-line v-if="this.articulosFiltrados.length>0" >
                    <template v-for="(item, index) in articulosFiltrados" >
                        
                        <v-list-item  @change="(agregarCarrito==false)? clicArt(item): ''" :key="item.COD_ART" v-ripple="{ class: 'blue-grey--text' }" >
                        
                        <v-list-item-avatar :rounded="true" size="80px" horizontal>
                            <Imagen v-if="item.imagen" :src="item.imagen" :src2="item.etiqueta"/>
                        </v-list-item-avatar>
                        

                        <v-list-item-content>
                            {{(item.DESC_CLIENTE)?item.DESC_CLIENTE:item.DESCRIPCION}}
                            <v-list-item-subtitle><span><b>Código: </b><b style="color:blue-grey;font-size:17px">{{item.COD_ART}}</b></span></v-list-item-subtitle>
                            <v-list-item-subtitle><span><b>Empaque: </b><b style="color:blue-grey;font-size:17px">{{(item.ESCALA!=item.ESC)?item.ESCALA:''}} {{item.CANT_EMPAQ}} {{item.ESC}}</b></span></v-list-item-subtitle>
                            <v-list-item-subtitle v-if="usuario.muestra_lista==1"><span><b>Precio contado: </b><b style="color:blue-grey;font-size:17px">{{precioArt(item) | toCurrency}}</b></span><span v-if="precioConIva" style="color:blue-grey;font-size: 13px;">{{` más IVA (${porcentajeIva(item)}%)`}}</span></v-list-item-subtitle>
                            <v-list-item-subtitle v-if="item.CANT_EMPAQ!=1 && usuario.muestra_lista==1"><span><b>Precio por empaque contado: </b><b style="color:blue-grey;font-size:17px">{{precioPorEmpaque(item) | toCurrency}}</b></span><span v-if="precioConIva" style="color:blue-grey;font-size: 13px;">{{` más IVA (${porcentajeIva(item)}%)`}}</span></v-list-item-subtitle>
                            
                            <!-- <div style="justify-content: end; display: grid;">
                                <v-btn v-if="(carrito.findIndex(i => i.cod_art==item.COD_ART)==-1)" color="blue-grey" @click="agregarCarrito=true,agregar(item)" elevation="0" outlined small dark style="max-width: 100px;"><v-icon style="font-size:20px">mdi-cart-outline</v-icon>{{(usuario.muestra_lista==1)?'Agregar':'Cotizar'}}</v-btn>
                                <template v-if="(carrito.findIndex(i => i.cod_art==item.COD_ART)!=-1)">
                                    <p style="color:green;margin: 0px;" class="mt-2"><v-icon style="font-size:20px" color="green">mdi-cart-check</v-icon>Agregado al carrito</p>
                                    <v-row class="mt-3" style="margin: auto;">
                                        <v-btn color="blue-grey" fab icon small @click="cantidadMenos(item)"><v-icon>mdi-minus-thick</v-icon></v-btn>
                                        <v-text-field
                                        v-model="carrito[carrito.findIndex(i => i.cod_art==item.COD_ART)].cantidad"
                                        label="Cantidad"
                                        type="number"
                                        dense
                                        flat
                                        solo
                                        hide-details="true"
                                        color="blue-grey"
                                        style="max-width: 95px;align-items: center;"
                                        @click="verDialogCantidad(carrito[carrito.findIndex(i => i.cod_art==item.COD_ART)])"
                                        class="centered-input text-blue-grey"
                                        readonly
                                        ></v-text-field>
                                        <v-btn color="blue-grey" fab icon small @click="cantidadMas(item)"><v-icon>mdi-plus-thick</v-icon></v-btn>
                                    </v-row>
                                    <p style="color:blue-grey;text-align: center;max-width: 168px;">{{descEmpaque(item)}}</p>
                                </template>
                            </div>
                            <div style="justify-content: end; display: grid;">
                                <template v-if="(carrito.findIndex(i => i.cod_art==item.COD_ART)==-1)">
                                    <v-chip v-if="item.pviejo && agrupador=='ofertas'" style="position: absolute;margin-top:107px; margin-left: -25px;" color="blue-grey" dark small>Antes:<span style="text-decoration: line-through">${{ item.pviejo }}</span> </v-chip>
                                </template>
                                <template v-else>
                                    <v-chip v-if="item.pviejo && agrupador=='ofertas'" style="position: absolute;margin-top:41px; margin-left: -25px;" color="blue-grey" dark small><span> Antes: </span> <br><span style="text-decoration: line-through">${{ item.pviejo }}</span> </v-chip>
                                </template>
                            </div> -->
                            <v-row no-gutters>
                                <v-col align-self="start" style="margin-top: 3px;">
                                    <template v-if="(carrito.findIndex(i => i.cod_art==item.COD_ART)==-1)">
                                        <v-chip v-if="item.pviejo && agrupador=='ofertas'" color="blue-grey" dark small>Antes:<span style="text-decoration: line-through">${{ item.pviejo }}</span> </v-chip>
                                    </template>
                                    <template v-else>
                                        <v-chip v-if="item.pviejo && agrupador=='ofertas'" color="blue-grey" dark small><span> Antes: </span> <br><span style="text-decoration: line-through">${{ item.pviejo }}</span> </v-chip>
                                    </template>
                                </v-col>
                                <v-col align-self="end">
                                    <v-btn v-if="(carrito.findIndex(i => i.cod_art==item.COD_ART)==-1)" color="blue-grey" @click="agregarCarrito=true,agregar(item)" elevation="0" outlined small dark style="max-width: 100px;"><v-icon style="font-size:20px">mdi-cart-outline</v-icon>{{(usuario.muestra_lista==1)?'Agregar':'Cotizar'}}</v-btn>
                                    <template v-if="(carrito.findIndex(i => i.cod_art==item.COD_ART)!=-1)">
                                        <p style="color:green;margin: 0px;margin-right:14px;margin-top: 3px;"><v-icon style="font-size:20px" color="green">mdi-cart-check</v-icon>Agregado al carrito</p>
                                        <v-row class="mt-3" style="margin: auto;">
                                            <v-btn color="blue-grey" fab icon small @click="cantidadMenos(item)"><v-icon>mdi-minus-thick</v-icon></v-btn>
                                            <v-text-field
                                            v-model="carrito[carrito.findIndex(i => i.cod_art==item.COD_ART)].cantidad"
                                            label="Cantidad"
                                            type="number"
                                            dense
                                            flat
                                            solo
                                            hide-details="true"
                                            color="blue-grey"
                                            style="max-width: 95px;align-items: center;"
                                            @click="verDialogCantidad(carrito[carrito.findIndex(i => i.cod_art==item.COD_ART)])"
                                            class="centered-input text-blue-grey"
                                            readonly
                                            ></v-text-field>
                                            <v-btn color="blue-grey" fab icon small @click="cantidadMas(item)"><v-icon>mdi-plus-thick</v-icon></v-btn>
                                        </v-row>
                                        <p style="color:blue-grey;text-align: center;max-width: 168px;">{{descEmpaque(item)}}</p>
                                    </template>
                                </v-col>
                            </v-row>
                            <!-- <v-row no-gutters>
                                <v-col align-self="start" style=" position: absolute; margin-left: -103px;">
                                    <template v-if="(carrito.findIndex(i => i.cod_art==item.COD_ART)==-1)">
                                        <v-chip v-if="item.pviejo && agrupador=='ofertas'" color="blue-grey" dark small>Antes:<span style="text-decoration: line-through">${{ item.pviejo }}</span> </v-chip>
                                    </template>
                                    <template v-else>
                                        <v-chip v-if="item.pviejo && agrupador=='ofertas'" color="blue-grey" dark small><span> Antes: </span> <br><span style="text-decoration: line-through">${{ item.pviejo }}</span> </v-chip>
                                    </template>
                                </v-col>
                                <v-col align-self="end" style="text-align-last: right;">
                                    <v-btn v-if="(carrito.findIndex(i => i.cod_art==item.COD_ART)==-1)" color="blue-grey" @click="agregarCarrito=true,agregar(item)" elevation="0" outlined small dark style="max-width: 100px;"><v-icon style="font-size:20px">mdi-cart-outline</v-icon>{{(usuario.muestra_lista==1)?'Agregar':'Cotizar'}}</v-btn>
                                    <template v-if="(carrito.findIndex(i => i.cod_art==item.COD_ART)!=-1)">
                                        <p style="color:green;margin: 0px;margin-right:14px" class="mt-2"><v-icon style="font-size:20px" color="green">mdi-cart-check</v-icon>Agregado al carrito</p>
                                        <v-row class="mt-3" style="margin: auto; display: inline-flex;" no-gutters>
                                            <v-btn color="blue-grey" fab icon small @click="cantidadMenos(item)"><v-icon>mdi-minus-thick</v-icon></v-btn>
                                            <v-text-field
                                            v-model="carrito[carrito.findIndex(i => i.cod_art==item.COD_ART)].cantidad"
                                            label="Cantidad"
                                            type="number"
                                            dense
                                            flat
                                            solo
                                            hide-details="true"
                                            color="blue-grey"
                                            style="max-width: 95px;align-items: center;"
                                            @click="verDialogCantidad(carrito[carrito.findIndex(i => i.cod_art==item.COD_ART)])"
                                            class="centered-input text-blue-grey"
                                            readonly
                                            ></v-text-field>
                                            <v-btn color="blue-grey" fab icon small @click="cantidadMas(item)"><v-icon>mdi-plus-thick</v-icon></v-btn>
                                        </v-row><br>
                                        <v-row class="mt-3" style="margin: auto; display: inline-flex;" no-gutters>
                                            <p style="color:blue-grey; margin-right: 52px;">{{descEmpaque(item)}}</p>
                                        </v-row >
                                    </template>
                                </v-col>
                            </v-row> -->
                        </v-list-item-content>
                       

                        </v-list-item>
                        <v-divider :key="index" :inset="item.inset"></v-divider>
            
                    </template>
                </v-list>
                <template v-if="this.articulosFiltrados.length==0 && !this.cargando">
                    <p style="text-align: center; margin-top:50px" ><v-icon>mdi-information-outline</v-icon> No hay artículos {{this.$route.params.agrupador}}</p>
                </template>
            </div>
            <!--FOOTER---------------->
            <v-footer :color=this.$azulUnarsa padless fixed class="mt-5" style="justify-content: end" rounded="0">
            <v-row justify="center" no-gutters style="height: 45px;">
                <v-col cols="4">

                </v-col>
                <v-col cols="4" class="text-center">
                    <v-btn style="bottom: 23px;" fab :color=this.$azulUnarsa elevation="20" @click="irHome" class="my-2"><v-icon color="white">mdi-plus-thick</v-icon></v-btn>
                </v-col>
                <v-col cols="4" class="text-end">
                    <v-btn @click="irCarrito" icon class="my-1 mr-2" color="white"><v-icon style="font-size:25px" color="#ffff">mdi-cart</v-icon>{{(carrito.length>0)?carrito.length:''}}</v-btn>
                </v-col>
            </v-row>
        </v-footer>
        </v-card>
         <!-- DIALOG CANTIDAD -->
        <v-dialog v-model="dialogCantidad" max-width="300px" persistent>
            <v-card v-if="itemCantSelected">
                <v-toolbar :color=this.$azulUnarsa>
                    <v-btn icon dark @click="cerrarDialogCambiarCantidad"><v-icon>mdi-arrow-left</v-icon></v-btn>
                    <v-card-title style="color:#ffff">Cambiar cantidad</v-card-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="mt-3" v-if="itemCantSelected">
                    <v-text-field autofocus outlined style="font-size: 20px;" v-model="carrito[carrito.findIndex(i => i.cod_art==itemCantSelected.cod_art)].cantidad" label="Cantidad" type="number" solo color="blue-grey"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-if="itemCantSelected" color="blue-grey" elevation="5" outlined @click="cambiarCantidad()" :disabled="!validarCantidad">Aceptar</v-btn>
                    <v-btn color="grey" elevation="5" @click="cerrarDialogCambiarCantidad" outlined>Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
         <!-- ----CARGANDO------- -->
        <v-overlay :value="cargando">
            <v-progress-circular
                indeterminate
                size="70"
                width="7"
            ></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import ApiServer from '../api';
import {mapState,mapActions} from 'vuex'
import Imagen from '../components/Imagen.vue'
export default {
    name:'ListaDeArticulos',
    components:{Imagen},
    data(){
        return{
            articulos:[],
            articulosFiltrados:[],
            cargando:false,
            agregarCarrito:false,
            itemCantSelected: null,
            dialogCantidad: false,
            busqueda: null,
            cargandoArticulos: false,
            agrupador : null
        }
    },
    methods:{
        ...mapActions(['agregarAlCarrito','editarCantCarrito','borrarArtCarrito']),
        async clicArt(item){
            try {
                await ApiServer.postUsoLog({
                   cod_cli: this.usuario.cod_cli,
                   usuario: this.usuario.nombreUsuario,
                   accion: `ARTICULO_${this.$route.params.agrupador.toUpperCase()}`,
                   dato: item.COD_ART
               })
                this.$router.push({name: 'Articulo', params: { codArt: item.COD_ART,datosArticulo:item }});
            } catch (error) {
                console.log(error);
            }
        },
        async agregar(item){
            this.cargando = true
            try {
                let result = await ApiServer.postCarritoCliente({
                    cod_cli:this.usuario.cod_cli,
                    cod_art:item.COD_ART,
                    cantidad: 1,
                    lpr_id:item.LISTA_ID,
                    usuario: this.usuario.nombreUsuario,
                    accion:`CARRITO_${this.$route.params.agrupador.toUpperCase()}`
                });
                this.agregarAlCarrito({
                    id:result.insertId,
                    lpr_id:item.LISTA_ID,
                    cod_art:item.COD_ART,
                    art_id:item.ART_ID,
                    desc_cliente: item.DESC_CLIENTE,
                    descripcion: item.DESCRIPCION,
                    mod:item.MOD,
                    med:item.MED,
                    desc_if:item.DESC_IF,
                    cantidad:1,
                    escala_id:item.ESCALA_ID,
                    escala:item.ESCALA,
                    esc:item.ESC,
                    esc_plu:item.ESC_PLU,
                    pr_vta:item.PR_VTA,
                    pr_cto_cpra:item.PR_CTO_CPRA,
                    pr_cto:item.PR_CTO,
                    pr_final:item.PR_FINAL,
                    descuento:item.DESCUENTO,
                    disponible:item.DISPONIBLE,
                    cant_empaq:item.CANT_EMPAQ,
                    ord_rec_str:item.ORD_REC_STR,
                    ean:item.EAN,
                    imagen : `https://loguin.com.ar/img/${item.ART_ID}.jpg?t=${(new Date()).getTime()}`,
                    etiqueta : item.etiqueta
                })
                this.cargando = false
            } catch (error) {
                this.cargando = false
                console.log(error);
            }
            setTimeout(()=>{
                this.agregarCarrito=false
            },1000)
          
        },
        async cantidadMas(item){
            this.agregarCarrito = true
            this.cargando = true
            try {
                let index = this.carrito.findIndex(i => i.cod_art==item.COD_ART)
                if((this.carrito[index].cantidad*this.carrito[index].cant_empaq)<item.DISPONIBLE){
                    let cant = this.carrito[index].cantidad+1
                    await ApiServer.putCarritoCliente({cantidad:cant,id:this.carrito[index].id})
                    this.editarCantCarrito({index:index,cantidad:cant})
                    this.cargando = false
                    setTimeout(()=>{
                        this.agregarCarrito=false
                    },2000)
                }else{
                    this.cargando = false
                    this.snackbar = true
                    this.snackbarColor ='error'
                    this.snackbarIcon = 'mdi-close-circle'
                    this.snackbarMsge='Sin stock'
                }
                
            } catch (error) {
                console.log(error);
                this.cargando = false
            }
        },
        async cantidadMenos(item){
            this.cargando = true
            this.agregarCarrito=true
            try {
                let index = this.carrito.findIndex(i => i.cod_art==item.COD_ART)
                if(index>=0){
                    if(this.carrito[index].cantidad>1){
                        let cant = this.carrito[index].cantidad-1
                        await ApiServer.putCarritoCliente({cantidad:cant,id:this.carrito[index].id})
                        this.editarCantCarrito({index:index,cantidad:cant})
                    }else{
                        await ApiServer.deleteCarritoCliente(this.carrito[index].id)
                        this.borrarArtCarrito(this.carrito[index].id)
                    }
                }
                this.cargando = false
                setTimeout(()=>{
                    this.agregarCarrito=false
                },2000)
            } catch (error) {
                 console.log(error);
                this.cargando = false
            }
        },
        verDialogCantidad(item){
            this.agregarCarrito=true
            this.itemCantSelected = item
            this.dialogCantidad = true
            setTimeout(()=>{
                this.agregarCarrito=false
            },2000)
        },
        async cambiarCantidad(){
            this.dialogCantidad = false
            this.cargando = true
            let cant = Number(this.itemCantSelected.cantidad)
            try {
                if(cant>0 && (cant <= this.itemCantSelected.disponible)){
                    let index = this.carrito.findIndex(i => i.cod_art==this.itemCantSelected.cod_art)
                    await ApiServer.putCarritoCliente({cantidad:cant,id:this.carrito[index].id})
                    this.editarCantCarrito({index:index,cantidad:cant})
                }
                this.cargando = false
                this.itemCantSelected = null
            } catch (error) {
                this.cargando = false
                this.dialogCantidad = false
                this.itemCantSelected = null
                console.log(error);
            }
        },
        cerrarDialogCambiarCantidad(){
            let index = this.carrito.findIndex(i => i.cod_art==this.itemCantSelected.cod_art)
            if(index>=0){
                let cant = this.carrito[index].cantidad*this.carrito[index].cant_empaq
                if(cant>=this.itemCantSelected.disponible){
                    this.carrito[index].cantidad=this.itemCantSelected.disponible/this.itemCantSelected.cant_empaq   
                }
                if(cant<=0){
                    this.carrito[index].cantidad = 1
                }
                this.dialogCantidad = false
            }
            this.itemCantSelected = null
        },
        atras(){
            this.$router.go(-1)
        },
        irCarrito(){
            this.$router.push({name: 'Carrito'});
        },
        irHome(){
            this.$router.push({name: 'Home'});
        },
        descEmpaque(item){
            let cant = this.carrito[this.carrito.findIndex(i => i.cod_art==item.COD_ART)].cantidad
            if(cant==1){
                if(item.ESCALA != item.ESC){
                    return `${cant} ${item.ESCALA} / ${cant*item.CANT_EMPAQ} ${item.ESC}`
                }else{
                    return `${cant} ${item.ESCALA}`
                }
            }else{
                if(item.ESCALA != item.ESC){
                    return `${cant} ${item.ESC_PLU} / ${cant*item.CANT_EMPAQ} ${item.ESC}`
                }else{
                    return `${cant} ${item.ESC_PLU}`
                }
            }
        },
        porcentajeIva(item){
            //IVA 10.5 o 21
            let x = item.PR_FINAL/item.PR_VTA
            if(Math.abs(21-(x-1)*100)<Math.abs(10.5-(x-1)*100)){
                return 21
            }else{
                return 10.5
            }
        },
        precioArt(item){
            let precio = null
            if(this.precioConIva){
                precio = item.PR_VTA + item.PR_VTA*(item.DESCUENTO/100)
            }else{
                precio = item.PR_FINAL + item.PR_FINAL*(item.DESCUENTO/100)
            }
            return Math.round(precio)
        },
        precioPorEmpaque(item){
            let precio = null
            if(this.precioConIva){
                let pr_vta= item.PR_VTA + item.PR_VTA*(item.DESCUENTO/100)
                precio = Math.round(pr_vta)*item.CANT_EMPAQ
            }else{
                let pr_final = item.PR_FINAL + item.PR_FINAL*(item.DESCUENTO/100)
                precio = Math.round(pr_final)*item.CANT_EMPAQ
            }
            return precio
        }
    },
    async mounted(){
        if(!this.$route.params.agrupador){
            this.$router.push({name:'Home'})
        }else{
            this.agrupador = this.$route.params.agrupador
            this.cargando = true
            this.cargandoArticulos = true
            try {
                let resultArt = await ApiServer.getListaArticulos(this.usuario.cod_cli,this.$route.params.agrupador)
                let etiquetas = await ApiServer.getEtiquetasProductos()
                for(const art of resultArt){
                    
                    let resultDatosArt =  await ApiServer.getArtLpr(art.cod_art,this.usuario.listas[0].LISTA_ID,this.usuario.cli_id)
                    if(resultDatosArt && resultDatosArt.length>0 && resultDatosArt[0].DISPONIBLE>0){
                        resultDatosArt[0].imagen=`https://loguin.com.ar/img/${resultDatosArt[0].ART_ID}.jpg`
                        resultDatosArt[0].pviejo = art.pviejo
                        // if(resultDatosArt[0].DESCUENTO && resultDatosArt[0].DESCUENTO>0){
                        //     resultDatosArt[0].PR_FINAL = resultDatosArt[0].PR_FINAL - resultDatosArt[0].PR_FINAL * (resultDatosArt[0].DESCUENTO/100)
                        //     resultDatosArt[0].PR_VTA = resultDatosArt[0].PR_VTA - resultDatosArt[0].PR_VTA * (resultDatosArt[0].DESCUENTO/100)
                        // }
                        let indexEtiqueta = etiquetas.findIndex(x=>x.cod_art==art.cod_art)
                        if(indexEtiqueta>-1){
                            resultDatosArt[0].etiqueta = `https://loguin.com.ar/img/imag_etiquetas/${etiquetas[indexEtiqueta].etiqueta}?t=${(new Date()).getTime()}` 
                        }else{
                            resultDatosArt[0].etiqueta = null
                        }
                        this.articulos.push(resultDatosArt[0])
                        this.articulosFiltrados.push(resultDatosArt[0])
                        if(!this.busqueda)
                        this.cargando = false
                    }
                }
                this.cargandoArticulos = false
                if(this.cargando){
                    this.cargando = false
                }
                if(this.busqueda!=null && this.busqueda!=''){
                    let buscar = this.busqueda.toLowerCase()
                    this.articulosFiltrados = this.articulos.filter(function(item){
                        if(item.DESC_CLIENTE){
                            return (item.DESC_CLIENTE.toLowerCase().includes(buscar))
                        }else if(item.DESCRIPCION){
                            return (item.DESCRIPCION.toLowerCase().includes(buscar))
                        }else{
                            return false
                        }
                    }) 
                }
            } catch (error) {
                this.cargando = false
                this.cargandoArticulos = false
                console.log(error);
            }
        }
    },
    computed:{
        ...mapState(['usuario','carrito']),
        validarCantidad(){
            let index = this.carrito.findIndex(i => i.cod_art==this.itemCantSelected.cod_art)
            if(index>=0){
                let cant = this.carrito[index].cantidad*this.carrito[index].cant_empaq
                if(cant>this.itemCantSelected.disponible || cant<=0){
                    return false
                }else{
                    return true
                } 
            }
        },
        precioConIva(){
            if(this.usuario.iva_id=='MO' || this.usuario.iva_id=='RI'){
                return true
            }else{
                return false
            }
        }
    },
    watch:{
        busqueda(){
            if(!this.cargandoArticulos){
                if(this.busqueda == '' || this.busqueda==null){
                    this.articulosFiltrados = this.articulos
                }else{
                    let buscar = this.busqueda.toLowerCase()
                    this.articulosFiltrados = this.articulos.filter(function(item){
                        if(item.DESC_CLIENTE){
                            return (item.DESC_CLIENTE.toLowerCase().includes(buscar))
                        }else if(item.DESCRIPCION){
                            return (item.DESCRIPCION.toLowerCase().includes(buscar))
                        }else{
                            return false
                        }
                    }) 
                    // this.articulosFiltrados = this.articulos.filter((item) => (item.DESC_CLIENTE.toLowerCase().includes(this.busqueda.toLowerCase())))
                }
            }else{
                this.cargando = true
            }
        },
    }
}
</script>
<style scoped>
    .centered-input >>> input {
      text-align: center;
      text-align-last: center;
    }
    .cant.v-text-field--outlined >>> fieldset {
    border-color: blue-grey;
    border-width: 2px;
    height: 35px;
    align-self: start;
    margin-top: 6px
    }
     .fixed-bar {
    position: sticky;
    position: -webkit-sticky; /* for Safari */
    top: 0em;
    z-index: 2;
    }
    
</style>